/**
 * Query keys, in the shape `@erpx/ui` defines (`[entity, 'list', params]` and
 * `[entity, 'detail', id]`) but with a concrete tuple type.
 *
 * `queryKeys.list` in the shared library declares an optional params argument
 * and returns a two- *or* three-element tuple, which TanStack Query's generics
 * cannot resolve — every call site ends up with a union it refuses. Requiring
 * the params object here removes the union without changing the key shape, so
 * caches built by this app and by the tenant app stay structurally identical.
 */

import { queryKeys as shared } from '@erpx/ui'

export type ListKey = readonly [string, 'list', Record<string, unknown>]

export function listKey(entity: string, params: Record<string, unknown> = {}): ListKey {
  return [entity, 'list', params] as const
}

export const detailKey = shared.detail
